import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class SessionInvalidationLog {
  id: string;
  userId: number;
  userAgent: string;
  ipAddress: string;
  jti: string;
  occurredAt: string;
  createdAt: string;
}

export class SessionInvalidationLogsResponse extends IPagination {
  @Type(() => SessionInvalidationLog)
  results: SessionInvalidationLog[];
}

export class SessionInvalidationLogQueryParams extends IQueryPaginationDto {
  userId?: number;
}
